import { usePointStore, usePolygonStore } from '@monopolio-ui/state-library'
import HeatMapTooltip from './HeatMapTooltip'
import Toggle from '../../Toggle'
import ThunderIcon from './ThunderIcon'

const HeatMapToggleSelector = (): JSX.Element => {
  const {
    isEnabledHeatMap,

    setIsEnabledHeatMap,
    clearPolygonNavigation,
  } = usePolygonStore()

  const { setIsEnablePropertiesPoints } = usePointStore()

  const onClick = (): void => {
    if (isEnabledHeatMap) {
      clearPolygonNavigation({
        state: true,
        municipality: true,
        neighborhood: true,
      })
    }
    setIsEnabledHeatMap(!isEnabledHeatMap)
    setIsEnablePropertiesPoints(isEnabledHeatMap)
  }

  return (
    <div className="relative">
      <div
        className={`${[
          'py-1.5 pr-1.5 pl-3 flex items-center gap-1 rounded-full duration-150',
          isEnabledHeatMap ? 'bg-black' : 'bg-white',
        ].join(' ')}`}
      >
        <div className="flex items-center">
          {isEnabledHeatMap ? (
            <ThunderIcon className="w-3 h-3 animation-appear-03" />
          ) : null}
          <p
            className={`text-body-bold-s duration-200 ${[
              isEnabledHeatMap ? 'text-white ml-1' : 'text-primary',
            ].join(' ')}`}
          >
            Ver zonas
          </p>
        </div>
        <Toggle onClick={onClick} size="sm" toggled={isEnabledHeatMap} />
      </div>

      <HeatMapTooltip />
    </div>
  )
}

export default HeatMapToggleSelector
